export default "__VITE_ASSET__D961vWPJ__"